const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : VideoVisibility
 */

function VideoVisibility(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

VideoVisibility.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_VideoVisibility = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const VideoVisibility_null_Init = new StateJS.State('Init', this._statemachine).entry(() => {
    this.InitVideoVisibility();
  });
  const VideoVisibility_null_PageVisible = new StateJS.State('PageVisible', this._statemachine);
  const VideoVisibility_null_PageHidden = new StateJS.State('PageHidden', this._statemachine).entry(() => {
    this.bus.emit('videoControl', new Event.Stop_VideoControllerMsg(this.name, 'videoControl'));
  });
  _initial_VideoVisibility.to(VideoVisibility_null_Init);
  VideoVisibility_null_PageVisible.to(VideoVisibility_null_PageHidden).on(Event.PageHidden_VideoVisibility).when((pageHidden) => pageHidden.port === 'pageVisibilityPort' && pageHidden.type === 'pageHidden');
  VideoVisibility_null_Init.to(VideoVisibility_null_PageHidden).on(Event.PageHidden_VideoVisibility).when((pageHidden) => pageHidden.port === 'pageVisibilityPort' && pageHidden.type === 'pageHidden');
  VideoVisibility_null_Init.to(VideoVisibility_null_PageVisible).on(Event.PageVisible_VideoVisibility).when((pageVisible) => pageVisible.port === 'pageVisibilityPort' && pageVisible.type === 'pageVisible');
  VideoVisibility_null_PageHidden.to(VideoVisibility_null_PageVisible).on(Event.PageVisible_VideoVisibility).when((pageVisible) => pageVisible.port === 'pageVisibilityPort' && pageVisible.type === 'pageVisible');
  VideoVisibility_null_PageHidden.on(Event.Playing).when((playing) => playing.port === 'videoControl' && playing.type === 'playing').effect((playing) => {
    this.bus.emit('videoControl', new Event.Stop_VideoControllerMsg(this.name, 'videoControl'));
  });
};
VideoVisibility.prototype.InitVideoVisibility = function () {
  let hiddenPropertyName = 'hidden';
  let visibilityChangeEventName = 'visibilitychange';

  if (typeof document.msHidden !== 'undefined') {
    hiddenPropertyName = 'msHidden';
    visibilityChangeEventName = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hiddenPropertyName = 'webkitHidden';
    visibilityChangeEventName = 'webkitvisibilitychange';
  }

  const triggerPageVisibilityMessage = () => {
    if (document[hiddenPropertyName]) {
      this.bus.emit('pageVisibilityPort', new Event.PageHidden_VideoVisibility(this.name, 'pageVisibilityPort'));
    } else {
      this.bus.emit('pageVisibilityPort', new Event.PageVisible_VideoVisibility(this.name, 'pageVisibilityPort'));
    }
  };

  document.addEventListener(visibilityChangeEventName, triggerPageVisibilityMessage, false);
  triggerPageVisibilityMessage();
};

VideoVisibility.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

VideoVisibility.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

VideoVisibility.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

VideoVisibility.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

VideoVisibility.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += '';
  return result;
};

module.exports = VideoVisibility;
